var _g, _path, _g2, _g3, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 38.814,
    viewBox: "0 0 30 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mp4",
    transform: "translate(-545.297 405.652)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_10",
    "data-name": "XMLID 83 10",
    transform: "translate(216.875 -1583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M328.422,1208.825l1.94,1.647v-1.647Z",
    fill: "#07499a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_10",
    "data-name": "XMLID 86 10",
    transform: "translate(216.875 -1583)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M349.221,1177.348h-18.85v38.814h28.051v-29.757Z",
    fill: "#5d5d5d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_10",
    "data-name": "XMLID 85 10",
    transform: "translate(216.875 -1583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M349.221,1177.348l9.2,9.068h-9.2Z",
    fill: "#5d5d5d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_10",
    "data-name": "XMLID 84 10",
    transform: "translate(216.875 -1583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 28,
    height: 13.286,
    transform: "translate(328.422 1195.54)",
    fill: "#07499a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_.mp4-2",
    "data-name": " .mp4-2",
    transform: "translate(216.875 -1583)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M329.661,1205.95a.66.66,0,0,1,.467-1.128.607.607,0,0,1,.453.192.682.682,0,0,1,0,.936.609.609,0,0,1-.453.191A.636.636,0,0,1,329.661,1205.95Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M340.319,1200.424a2.043,2.043,0,0,1,.84.845,2.823,2.823,0,0,1,.309,1.373v3.435h-.958v-3.3a1.89,1.89,0,0,0-.43-1.335,1.515,1.515,0,0,0-1.165-.463,1.558,1.558,0,0,0-1.2.484,1.991,1.991,0,0,0-.447,1.4v3.212h-.957v-3.3a1.89,1.89,0,0,0-.431-1.335,1.513,1.513,0,0,0-1.165-.463,1.56,1.56,0,0,0-1.2.484,1.991,1.991,0,0,0-.447,1.4v3.212H332.1v-5.829h.968v.841a1.929,1.929,0,0,1,.771-.7,2.342,2.342,0,0,1,1.07-.244,2.519,2.519,0,0,1,1.3.33,2.014,2.014,0,0,1,.841.968,1.913,1.913,0,0,1,.808-.958,2.388,2.388,0,0,1,1.255-.34A2.551,2.551,0,0,1,340.319,1200.424Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M344.919,1200.488a2.556,2.556,0,0,1,1.325-.335,2.73,2.73,0,0,1,1.409.372,2.625,2.625,0,0,1,.995,1.048,3.284,3.284,0,0,1,.361,1.568,3.361,3.361,0,0,1-.361,1.575,2.653,2.653,0,0,1-2.4,1.457,2.543,2.543,0,0,1-1.314-.335,2.378,2.378,0,0,1-.867-.835v3.84H343.1v-8.595h.968v1.075A2.306,2.306,0,0,1,344.919,1200.488Zm2.835,1.505a1.842,1.842,0,0,0-.718-.745,1.99,1.99,0,0,0-.994-.255,1.931,1.931,0,0,0-.984.261,1.9,1.9,0,0,0-.724.755,2.569,2.569,0,0,0,0,2.3,1.907,1.907,0,0,0,.724.756,1.931,1.931,0,0,0,.984.26,1.955,1.955,0,0,0,.994-.26,1.873,1.873,0,0,0,.718-.756,2.426,2.426,0,0,0,.266-1.165A2.371,2.371,0,0,0,347.754,1201.993Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M349.934,1204.365v-.734l3.734-5.17h1.159v5.064h1.064v.84h-1.064v1.712h-.957v-1.712Zm3.979-4.893-2.862,4.053h2.862Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.504ac64246fa352e601e4ade34735f4d.svg";
export { ForwardRef as ReactComponent };